import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FAQSection from './components/FAQSection';
import CarouselSection from './components/CarouselSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <FAQSection />
        <CarouselSection />
        <FeaturesSection />
        <TopicsSection />
        <MediaSection />
        <ContactSection />
        <RankingSection />
        <CardsSection />
        <UpdatesSection />
        <CommentsSection />
        <IndexSection />
        <AppSection />
        <AboutSection />
      </main>
      <Footer />
    </div>
  );
}